<template>
	<b-container fluid>
		<b-row>
			<b-col xl="8" offset-xl="2" lg="10" offset-lg="1" class="my-5">
				<h2>Trilhas Sonoras</h2>
				<rb-loader v-if="!loaded" center></rb-loader>

				<transition name="fade">
					<b-row v-if="loaded">
						<b-col md="3" class="mb-4 text-center" v-for="s in soundtracks" :key="s.Id">
							<h3 class="mt-3 mb-0">{{s.Name}}</h3>
							<small class="text-grey">Lançado em {{s.Date.format('d/m/Y')}}</small>

							<rb-thumbnail
								class="rb-ost-thumbnail my-3"
								:image-url="s.ImageUrl"
								:active="false"
								square />

							<span
								v-for="link in s.Links"
								:key="link.Order">
								<a :href="link.Url" target="_blank">
									{{link.Name}}
								</a> <br>
							</span>

						</b-col>
					</b-row>
				</transition>
			</b-col>
		</b-row>
	</b-container>
</template>

<script>
	import RbLoader from '../components/RbLoader';
	import RbThumbnail from '../components/RbThumbnail';

	export default {
		name: 'Soundtracks',
		components: {RbThumbnail, RbLoader},
		metaInfo (){
			return {
				title: 'Trilhas Sonoras'
			}
		},
		data: () => ({
			loaded: false,
			soundtracks: []
		}),
		async mounted() {
			this.soundtracks = await this.$oldApi.Soundtracks.list();

			this.loaded = true;
		}
	}
</script>
<style lang="scss" scoped>

</style>